import React, { useEffect, useState } from "react";
import {
  getDropdownData,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import LoadingSpinner from "../../LoadingSpinner";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const MISReportSearch = ({
  searchResHandler,
  resetHandler,
  reportType,
  setReportType,
}) => {
  const userData = useSelector((state) => state.user.userDetails);
  const user = useSelector((state) => state.user);

  const [reportTypeOptions, setReportTypeOptions] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [customer, setCustomer] = useState("");
  const [transporter, setTransporter] = useState("");
  const [shipper, setShipper] = useState("");
  const [jobNos, setJobNos] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [vehicleNos, setVehicleNos] = useState("");

  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reloadDates, setReloadDates] = useState(true);
  const [searchFieldReset, setSearchFieldReset] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const reportTypeData = await getDropdownData("report_name");
      setReportTypeOptions(reportTypeData);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

  const onSearch = (e) => {
    if (!reportType || !fromDate || !toDate) {
      toast.warn("report type and date type are mandatory", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    e.preventDefault();
    searchResHandler({
      reportType: reportType,
      fromDate: getValueOrDefault(fromDate),
      toDate: getValueOrDefault(toDate),
      customer: getValueOrDefault(customer),
      transporter: getValueOrDefault(transporter),
      shipper: getValueOrDefault(shipper),
      jobNos: getValueOrDefault(jobNos),
      vehicleType: getValueOrDefault(vehicleType),
      vehicleNos: getValueOrDefault(vehicleNos, "-2").toUpperCase(),
    });
  };

  function getValueOrDefault(value, defaultValue = "-2") {
    if (Array.isArray(value)) {
      return value.length > 0 ? value.join(",") : defaultValue;
    }
    return value && value.toString().trim() !== ""
      ? value.toString()
      : defaultValue;
  }

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setReportType(1);
    setCustomer("");
    setTransporter("");
    setShipper("");
    setJobNos("");
    setVehicleNos("");
    setVehicleType("");
    setReloadDates(true);
    resetHandler();

    setTimeout(() => setResetSearchFields(false), 0);
  };

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <form className="ui form">
          <h4 className="ui dividing header">Information</h4>
          <div
            className="three fields"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div className="field">
              <Dropdown
                required={true}
                options={reportTypeOptions}
                label="Report Type"
                placeholder="Report Type"
                style={{ height: "20px" }}
                value={reportType}
                onChange={(e, data) => {
                  setReportType(data.value);
                }}
                clearable={false}
              />
            </div>
            <div className="field">
              <Input
                required={true}
                type="date"
                label="From Date"
                name="fromDate"
                max={toDate ?? new Date().toISOString().split("T")[0]}
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                }}
              />
            </div>
            <div className="field">
              <Input
                required={true}
                label="To Date"
                type="date"
                name="toDate"
                min={fromDate}
                value={toDate}
                disabled={!fromDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                }}
              />
            </div>
          </div>
          <div
            className="three fields"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div className="field">
              <label>Job Numbers</label>
              <input
                type="text"
                placeholder="Ex:JOB-0000123"
                name="jobnos"
                value={jobNos}
                onChange={(e) => {
                  setJobNos(e.target.value);
                }}
              />
            </div>
            <div className="field">
              <SearchDropdown
                key={
                  resetSearchFields
                    ? `vehicle_type_reset_${Date.now()}`
                    : "vehicle_type"
                }
                editMode={false}
                reset={searchFieldReset}
                setReset={setSearchFieldReset}
                clearable={true}
                value={vehicleType}
                onClear={() => {
                  setVehicleType("");
                }}
                onResultSelect={(data) => setVehicleType(data)}
                api={getOtherRefSearchDropdown}
                apiDependency={{
                  type: "vehicle_type",
                  value: "",
                }}
                label="Vehicle Type"
              />
            </div>
            <div className="field">
              <label>Vehicle Numbers</label>
              <input
                type="text"
                placeholder="Ex:LG-0123"
                name="vehnos"
                value={vehicleNos}
                onChange={(e) => {
                  setVehicleNos(e.target.value);
                }}
              />
            </div>
          </div>
          <div
            className="three fields"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div className="field">
              <SearchDropdown
                key={1}
                editMode={false}
                reset={resetSearchFields}
                setReset={setResetSearchFields}
                clearable={true}
                onClear={() => {
                  setCustomer("");
                }}
                onResultSelect={(data) => setCustomer(data)}
                api={getOtherRefSearchDropdown}
                apiDependency={
                  userData.type === 1
                    ? {
                        type: "stakeholder_type",
                        value: "Customer",
                      }
                    : {
                        type: "user_stakeholder",
                        value: "Requesting Customer",
                        param2: user.username,
                      }
                }
                label="Customer"
              />
            </div>
            <div className="field">
              <SearchDropdown
                key={1}
                editMode={false}
                reset={resetSearchFields}
                setReset={setResetSearchFields}
                clearable={true}
                onClear={() => {
                  setShipper("");
                }}
                onResultSelect={(data) => setShipper(data)}
                api={getOtherRefSearchDropdown}
                apiDependency={
                  userData.type === 1
                    ? {
                        type: "stakeholder_type",
                        value: "Shipper",
                        param2: customer?.toString(),
                      }
                    : {
                        type: "user_stakeholder",
                        value: "Shipper",
                        param1: customer?.toString(),
                        param2: user.username,
                      }
                }
                label="Shipper/Plant"
              />
            </div>
            <div className="field">
              <SearchDropdown
                key={1}
                editMode={false}
                reset={resetSearchFields}
                setReset={setResetSearchFields}
                clearable={true}
                onClear={() => {
                  setTransporter("");
                }}
                onResultSelect={(data) => setTransporter(data)}
                api={getOtherRefSearchDropdown}
                apiDependency={{
                  type: "stakeholder_type",
                  value: "Transporter",
                }}
                label="Transporter"
              />
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div className="field" style={{ width: "100%" }}>
              <Button template="search" onClick={onSearch} />
              <Button template="searchReset" onClick={onReset} />
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default MISReportSearch;
